import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

import type { SchedulePeriod } from 'bundles/course-sessions/types/LearnerCourseSchedule';

const api = API('/api/onDemandCourseSchedules.v1');

type NaptimeResponse<R> = {
  elements: Array<R>;
  linked: any;
  paging: any;
};

type Schedule = {
  defaultSchedule: {
    periods: Array<SchedulePeriod>;
  };
};

type DefaultScheduleResponse = NaptimeResponse<Schedule>;

export const getCourseSchedule = (courseId: string): Q.Promise<DefaultScheduleResponse> => {
  const courseScheduleUri = new URI(courseId).addQueryParam('fields', 'defaultSchedule');
  return Q(api.get<DefaultScheduleResponse>(courseScheduleUri.toString()));
};
